import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { logger } from "@/lib/logger";
import { isNativeApp } from "@/lib/native";
import { useAuthStore } from "@/store/authStore";

/**
 * 네이티브 PurchaseBridge.onCustomerInfoUpdated 콜백을 등록하여
 * 구독 상태가 변경되면 isPlus 쿼리 캐시를 즉시 갱신한다.
 */
export function usePurchaseListener() {
  const queryClient = useQueryClient();
  const userId = useAuthStore(state => state.user?.id);

  useEffect(() => {
    if (!isNativeApp || !userId || !window.PurchaseBridge) {
      return;
    }

    window.PurchaseBridge.onCustomerInfoUpdated = info => {
      logger.info({ domain: "purchase", message: "CUSTOMER_INFO_UPDATED 수신", data: { isPlus: info.isPlus } });
      queryClient.setQueryData(["isPlus", userId], info.isPlus);
    };

    return () => {
      if (window.PurchaseBridge) {
        window.PurchaseBridge.onCustomerInfoUpdated = null;
      }
    };
  }, [queryClient, userId]);
}
